import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollCreateUserPerquisiteAssignmentsResponse,
  PayrollCreateUserPerquisiteAssignmentsVariables,
} from './types';

export const createUserPerquisiteAssignmentsMutation = gql`
  mutation PayrollCreateUserPerquisiteAssignments(
    $userComponent: [CreatePerquisiteComponentAssignmentInput!]!
  ) {
    payrollCreateUserPerquisiteAssignments(userComponent: $userComponent) {
      data
      code
      success
      message
    }
  }
`;

const createUserPerquisiteAssignments = (
  queryVariables: PayrollCreateUserPerquisiteAssignmentsVariables,
) => {
  return graphQLApi<
    PayrollCreateUserPerquisiteAssignmentsResponse,
    PayrollCreateUserPerquisiteAssignmentsVariables
  >({
    query: createUserPerquisiteAssignmentsMutation,
    queryVariables,
  });
};

export default createUserPerquisiteAssignments;
